
<script>
    import { mapState,mapActions, mapGetters } from 'vuex';
    import CardLimitMixin from "../../../author/pagesbuilder/mixins/CardLimitMixin";
    import SliderMixin from "../../../author/pagesbuilder/mixins/SliderMixin";
    import RowsMixin from "../../../author/pagesbuilder/mixins/RowsMixin";

    export default {
        name: "BlogPostCardsComponent",
        mixins: [
            SliderMixin,
            RowsMixin,
            CardLimitMixin
        ],
        data () {
            return {
                componentType: "blog-post-cards",
                currentRenderData : {},
                blogPosts: [],
                page: 1,
                paginationTotalItems: 0,
                paginationTotalPages: 0,
                paginationItemsPerPage: 0,
                blogPostCategories: [],
                selectedCategory: null,
                searchQuery: null,
            }
        },
        computed: {           
            contextWrapper () {
                return this.hasContext("context-wrapper") ? this.findNodeState(this.hasContext("context-wrapper")[0].id) : null;
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    styles: {},
                    template: 'basicComponentTemplate',
                    cardType: this.getDefaultCardType,
                    showSlider: false,
                    filters: {
                        search: true,
                        categories: true
                    },
                    rows: 1, // this is the currentPage. increments on every click of load more
                    cardsPerRow: 4, // how many cards will load on each page
                    limitAmountOfCards: true, // flag that enables pagination on cards rendering
                    cardsLoadOption: 'load-more',
                    itemVisibilitySettings: null
                }
            },            
            availableCards () {
                return [
                    {
                        cardFilename : "blogpostcard1",
                        forSectionTemplate: "BlogPosts1",
                        layout: "basicComponentTemplate",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/blogcard1.jpg"
                    },
                    {
                        cardFilename : "blogpostcard2",
                        forSectionTemplate: "BlogPosts2",
                        layout: "basicComponentTemplate",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/blogcard2.jpg"
                    },
                    {
                        cardFilename : "blogpostcard3",
                        forSectionTemplate: "BlogPosts3",
                        layout: "basicComponentTemplate",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/blogcard3.jpg"
                    },
                    {
                        cardFilename : "blogpostcard1",
                        forSectionTemplate: "BlogPosts4",
                        layout: "basicComponentTemplate",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/blogcard1.jpg"
                    },
                    {
                        cardFilename : "blogpostcard2",
                        forSectionTemplate: "BlogPosts5",
                        layout: "basicComponentTemplate",
                        thumbnail : this.imagePath + "/author/images/pagesbuilder/blogcard2.jpg"
                    },
                ]
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        label : this.translations.load_more,
                        display: this.paginationTotalItems && (this.currentRenderData.rows * this.currentRenderData.cardsPerRow < this.paginationTotalItems),
                        template: "load-more",
                        executableFunction : this.loadMoreClicked
                    },
                    {
                        label : this.translations.see_all,
                        display: true,
                        template: "see-all",
                        executableFunction : this.seeAllClicked
                    },
                ]
            },
            getDefaultCardType () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let cardTypeData = this.availableCards.find(cardData => sectionTemplateId === cardData.forSectionTemplate);

                if (sectionState && cardTypeData) {
                    return cardTypeData.cardFilename;
                }

                return this.availableCards[0] ? this.availableCards[0].cardFilename : "";
            },
            translations () {
                return {
                    "load_more" : this.$t('blog.load_more'),
                    "see_all" : this.$t('blog.see_all'),
                }
            },
            loadPostParams(){
                const params = {
                    limit: this.componentData.cardsPerRow
                };
                if(this.page > 1){
                    params['page'] = this.page
                }
                if(this.selectedCategory){
                    params['categories'] = this.selectedCategory;
                }
                if(this.searchQuery){
                    params['search'] = this.searchQuery;
                }
                params['site_template'] = true;

                return params;
            },
            filters(){
                return this.myData.filters;
            },
            filterTemplate(){
                const sectionState = this.findNodeState(this.sectionId);
                if (!sectionState) {
                    return null;
                }

                const sectionTemplateId = sectionState.sectionTemplateId;                
                const templateMapping = {
                    'BlogPosts4' : 'BlogPostCardFilters1',
                    'BlogPosts5' : 'BlogPostCardFilters2',
                    'BlogPosts7' : 'BlogPostCardFilters3',
                };

                return templateMapping[sectionTemplateId] ? templateMapping[sectionTemplateId] : null; 
                

            }
        },
        methods : {
            ...mapGetters('blog', [
                'blogPostsQuery'
            ]),
            editBlogPostsData (blogPosts) {                
                return blogPosts.map(blogPost => {                    
                    blogPost.date = LWTranslate.formatTimestampLocalized(blogPost.published, "MMMM D, YYYY");

                    if (blogPost.image) {
                        blogPost.fullImagePath =  this.serverImg + blogPost.image;
                    } else if (blogPost.seo.image) {
                        blogPost.fullImagePath =  this.serverImg + blogPost.seo.image;
                    } else {
                        blogPost.fullImagePath =  this.imagePath + "/images/default_blog-post_image.jpg";
                    }

                    if (blogPost.author_name) {
                        blogPost.hasAuthor = true;
                    }

                    return blogPost;
                });
            },
            removePrivate (blogPosts) {
                return blogPosts.filter((blogPost) => {
                    return blogPost.access !== 'private' ;
                })
            },                        
            renderComponent () {                
                return this.renderBlogPosts(this.blogPosts);
            },
            loadPostsPage(){
                return new Promise((resolve, reject) => {
                    this.loadPosts().then(response => {
                        if(response.data.blogPosts){
                            if(this.page == 1){
                                this.blogPosts = [];
                            }
                            let blogPosts = response.data.blogPosts;
                            this.paginationTotalItems = response.data.pagination.totalItems;
                            this.paginationTotalPages = response.data.pagination.totalPages;
                            this.paginationItemsPerPage = response.data.pagination.itemsPerPage;
                            this.blogPostCategories = response.data.blogPostsCategories;
                            
                            
                            blogPosts = this.editBlogPostsData(blogPosts);
                            
                            this.blogPosts = this.blogPosts.concat(blogPosts);                           
                            return resolve(this.blogPosts);
                        }
                        return reject();
                    }) 
                });
            },
            loadPosts(){
                return this.blogPostsQuery()(this.loadPostParams);
            },
            renderBlogPosts (blogPosts) {
                let amountOfCards = blogPosts.length;

                let cardsPerPage = (this.componentData.cardsPerRow > amountOfCards || !this.componentData.limitAmountOfCards) ? amountOfCards : this.componentData.cardsPerRow;

                let renderData = {
                    ...this.componentData,
                    data: blogPosts,
                    amountOfCards,
                    cardsPerRow: cardsPerPage,
                };
                if (blogPosts.length === 0) {
                    return this.renderNoResultsMessage();
                }

                this.currentRenderData = renderData;

                this.renderTemplate(renderData.template, renderData).then( output => {
                    this.componentNode.innerHTML = output;
                    this.createCardListeners();
                    this.currentRenderData = renderData;
                    this.renderingCompleted(renderData);
                })
            },
            renderNoResultsMessage () {
                let renderData = {
                    template: 'nocontentmessage',
                    data: { content: "No posts found" }
                };
                this.renderTemplate(renderData.template, renderData).then( output => {
                    this.componentNode.innerHTML = output;
                    this.createCardListeners();
                    this.currentRenderData = renderData;
                    this.renderingCompleted(renderData);
                })
            },
            seeAllClicked () {

            },
            loadMoreClicked () {

            },
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null);
                        return true;
                    }
                })
            },
            createCardListeners () {},            
            selectCategory(category){
                this.selectedCategory = category;
                this.resetResults();                
                this.loadPostsPage().then(()=>{
                    this.setRows({value: 1});
                });
            },
            resetResults(){
                this.page = 1;
                this.currentRenderData ={}
                //this.blogPosts =[];
                
            },
            setSearchQuery(search){                
                this.searchQuery = search;
                this.selectedCategory = null;
                this.resetResults();                
                this.loadPostsPage().then(()=>{
                    this.setRows({value: 1});
                });
            },
            setFilters(value){               
               const mergedVal = {
                   ...this.myData.filters,
                   ...value
               }                
               this.changeMyData({filters: mergedVal });
               this.setChangesAreSaved(false);
            }

        },
        watch : {
            "myData.cardType": {
                handler (newVal, oldVal){
                    // console.log(" 1 cardType newVal, oldVal: " , newVal, oldVal , this.myId)
                    if (newVal !== oldVal && !this.renderInProgress) {
                        this.debouncedRenderComponent();
                    }
                }
            },
            "myData.cardsLoadOption": {
                handler (newVal, oldVal){
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            },            
            blogPosts: {
                handler(newVal, oldVal){
                    if (newVal !== oldVal) {
                        this.debouncedRenderComponent();
                    }
                }
            }            
        },
    }
</script>
